import { Component, ElementRef } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable, Subject } from "rxjs";

import { BfxDialogData } from "./models/bfx-dialog-data.model";

import { BfxDialogBaseComponent } from "./bfx-dialog-base.component";

import { OrdersTableDefinitionFactory, TableDefinition } from "shared/cubiq-services";
import { GoldenLayoutService } from "../golden-layout/golden-layout-service";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { BFXDialogIntent } from "app/bfx-dialogs/models/bfx-dialog-intent.enum";
import { NativeDesktopSupport } from "../bfx-native-desktop/native-desktop-support";

@Component({
  selector: `bfx-dialog-ok`,
  templateUrl: `./html/bfx-dialog-ok.html`,
  standalone: false,
})
export class BfxDialogOKComponent extends BfxDialogBaseComponent {
  public title: string = "";
  public messages: Array<string> = [];
  public tableDefinition: TableDefinition = null;
  public showConfirmationMessage: boolean = true;
  public confirmed: boolean = false;
  public subMessage: any = null;
  public okLabel: string = "OK";
  public cancelLabel: string | null = null;

  public data: any = {
    dialogId: null,
    dialogEventSubject: new Subject<BfxDialogData>(),
    actionEvent: null,
    payload: null,
    dialogData: {
      show: false,
      width: 450,
      count: 0,
      stlClass: "bfx-dialog-normal",
    },
  };

  constructor(
    protected layoutService: GoldenLayoutService,
    protected translationService: TranslateService,
    ordersTableDefinitionFactory: OrdersTableDefinitionFactory,
    protected _element: ElementRef,
  ) {
    super();
    this.tableDefinition = ordersTableDefinitionFactory.createDef();
  }

  public openDialog(_dialogData: BfxDialogData): Observable<any> {
    try {
      this.data.dialogId = _dialogData.dialogId;
      this.data.actionEvent = _dialogData.event;
      this.data.payload = _dialogData.payload;

      if (_dialogData.payload != null) {
        this.messages = _dialogData.payload.messages;
        this.title = _dialogData.payload.title;

        if (_dialogData.payload.showConfirmationMessage != null) {
          this.showConfirmationMessage = _dialogData.payload.showConfirmationMessage;
        }

        this.data.dialogData.stlClass = this.getDialogStyleClass(_dialogData);
      }

      if (this.messages.length > 0) {
        this.title = this.translationService.instant(this.title);
        NativeDesktopSupport.prepareEmbeddedDialog(_dialogData.body, this._dialog, this._element);
        this.data.dialogData.show = true;
      }
    } catch (ex) {
      logger.out.error("ERROR: BfxDialogOKComponent.openDialog(): Dialog exception! msg:", ex);
    }

    return this.data.dialogEventSubject.asObservable();
  }

  /**
   * Get the style call from the dialog data - if no intent property is
   * found in the payload, the style will default to 'bfx-dialog-normal'
   * @param dialogData
   * @returns
   */
  private getDialogStyleClass(dialogData: BfxDialogData): string {
    let intent = dialogData.payload.intent as BFXDialogIntent;
    if (intent == undefined || intent == null) {
      intent = BFXDialogIntent.NORMAL;
    }
    let dialogStyleClass;
    switch (intent) {
      case BFXDialogIntent.INFO:
        dialogStyleClass = "bfx-dialog-info";
        break;
      case BFXDialogIntent.NEUTRAL:
        dialogStyleClass = "bfx-dialog-neutral";
        break;
      case BFXDialogIntent.WARNING:
        dialogStyleClass = "bfx-dialog-warning";
        break;
      case BFXDialogIntent.NEGATIVE:
        dialogStyleClass = "bfx-dialog-negative";
        break;
      case BFXDialogIntent.POSITIVE:
        dialogStyleClass = "bfx-dialog-positive";
        break;
      case BFXDialogIntent.NORMAL:
      default:
        dialogStyleClass = "bfx-dialog-normal";
        break;
    }
    return dialogStyleClass;
  }

  public closeDialog(): void {
    if (this.data.payload.callbackNegative && !this.confirmed) {
      this.data.payload.callbackNegative(this.data.actionEvent);
    }

    super.closeDialog();

    this.data.dialogData.title_text = null;
    this.data.dialogData.message_text = null;
    this.data.dialogData.message_text_ids = null;
    this.data.actionEvent = null;
    this.data.payload = null;
    this.data.dialogData.show = false;

    // inform dialog service that dialog is closed and to cleanup
    this.notifyDialogClosed(this.data.dialogEventSubject, this.data.dialogId);
  }

  public actionConfirmed(): void {
    this.confirmed = true;
    if (this.data.payload.callback) {
      this.data.payload.callback(this.data.actionEvent);
    }
    this.closeDialog();
  }
}
